<template>
    <div class="gray-back" style="padding:.2rem 0 8rem 0">
        <van-form
                @submit="onSubmit"
                @failed="onFailed"
        > 
        <van-divider>食宿人数{{sai_member_count}}人</van-divider>
<van-notice-bar
  wrapable
  :scrollable="false"
  text="根据您这里填写的食宿人数配发餐券和乘坐大巴，请您认真核对!"
/>            <van-cell-group>
                <van-cell
                        input-align="right"
                        title="领队"
                        :value="row.lingdui_shisu_count"
                >
                <van-stepper v-model="row.lingdui_shisu_count"  :min="0"   />
                </van-cell>
                <van-cell
                        input-align="right"
                        title="运动员"
                        :value="row.yundongyuan_shisu_count"
                > 
                <van-stepper v-model="row.yundongyuan_shisu_count"  :min="row.yundongyuan_count"   />
                </van-cell>
                <van-cell
                        input-align="right"
                        title="教练员"
                        :value="row.jiaolian_shisu_count"
                > 
                <van-stepper v-model="row.jiaolian_shisu_count"  :min="1"   />
                </van-cell>
                <van-cell
                        input-align="right"
                        title="随行人员"
                        :value="row.suixing_shisu_count"
                > 
                <van-stepper v-model="row.suixing_shisu_count"  :min="0"   />
                </van-cell>
                <van-cell
                    v-if="row.saiqu.userdiydate==1"
                        input-align="right"
                        title="入住/离开酒店日期"
                        is-link
                        @click="dateShow = true" 
                > 
                {{row.date_range[0]}}<br/>{{row.date_range[1]}}
                </van-cell> 
                <van-calendar v-model="dateShow" :default-date="formData.date_range" type="range" @confirm="onDateConfirm" />
                <!-- <van-cell
                        input-align="right"
                        title="裁判员"
                        :value="row.caipan_count"
                /> -->
                <!-- <van-field
                        readonly
                        clickable
                        right-icon="arrow"
                        input-align="right"
                        label="随行人员"
                        placeholder="请选择人员"
                        @click="showFamliyPicker = true"
                />
                    <div class="operate-desc-left">
                        跟大会安排并缴费食宿费和餐车费的随行家长需添加身份证信息，若全程不跟大会，请勿添加。
                      </div> -->
                <!-- <FamliyPicker
                        :show="showFamliyPicker"
                        :limit="100"
                        @onChange="onFamliyChange"
                        @onClose="showFamliyPicker=false"
                        :defaultValue="formData.famliy"
                        @onConfirm="onFamliyConfirm"
                ></FamliyPicker>
                <div class="memberResultWrap" v-show="formData.famliy.length>0">
                    <div class="memberLi" v-for="(famliy ,index) in formData.famliy" :key="index">
                        随行人员{{index+1}}
                        <van-tag

                                :key="index"
                                round
                                color="#fff"
                                text-color="#666"
                                size="large"
                                closeable
                                type="primary"
                                @close="formData.famliy.splice(index,1)"
                        > {{famliy.name}} {{famliy.num}}
                        </van-tag>
                    </div>

                </div> -->
            </van-cell-group>
            <div class="savebtn">
              <van-button
                  color="linear-gradient(90deg, rgb(254, 200, 53) 0%, rgb(255, 173, 25) 100%)"
                  style="width: 2rem"
                  size="normal" round  native-type="button" v-rblink="{name:'ISaiApplyFormStep2',query:{id:this.$route.query.id}}">上一步</van-button>
                <van-button
                        style="width: 2rem"
                        size="normal" round :disabled="saveLoading" :loading="saveLoading" loading-text="保存中..." native-type="submit" @click="formData.need_shisu=2">不要食宿</van-button>
                <van-button
                        color="linear-gradient(90deg, rgb(254, 200, 53) 0%, rgb(255, 173, 25) 100%)"
                        style="width: 3rem"
                        size="normal" round :disabled="saveLoading" :loading="saveLoading" loading-text="提交中..." native-type="submit" @click="formData.need_shisu=1">保存并选择食宿
                </van-button>
            </div>
        </van-form>
    </div>
</template>
<style scoped>
    .box {
        /*margin-bottom: 1.5rem;*/
    }
    .memberResultWrap{
        background: #F3F3F3;
        margin: 0.2rem;
        border-radius: 8px;
        padding: 0.2rem;
    }
    .memberResultWrap .memberLi{
        font-size: 14px;
        color: #666;
        height: 36px;
        line-height: 36px;
    }
    .memberResultWrap .memberLi .van-tag{
        width: auto !important;
    }
    .savebtn {
        position: fixed;
        bottom: 0;
        padding-bottom: 0.2rem;
        width: 100%;
        z-index: 10;
        display: flex;
        flex: 1;
        flex-direction: row;
        justify-content: space-around;
        background: linear-gradient(180deg,hsla(0,0%,100%,0),#fff);
    }
    .van-tag {
        width: 55px;
        margin-left: 10px;
        text-align: center;
    }
    .between {
        justify-content: space-between;
    }
</style>
<script>
    import Vue from 'vue';
    import area from "../../../utils/area";
    import validator from "../../../utils/validator";
    import PicUploader from '@/components/picker/PicUploader.vue';
    import FileUploader from '@/components/picker/FileUploader.vue';
    import {Cell,Field,Area,Form,Divider,Calendar, CellGroup,RadioGroup,Radio,ActionSheet,Icon, Toast, Popup, Picker, Sidebar, SidebarItem, Tag, Stepper ,Switch ,Button} from 'vant';
    import CaipanPicker from '@/components/picker/CaipanPicker.vue';
    import JiaolianPicker from '@/components/picker/JiaolianPicker.vue';
    import FamliyPicker from '@/components/picker/FamliyPicker.vue';
    Vue.use(Cell).use(CellGroup).use(Form).use(Divider).use(Area).use(ActionSheet).use(RadioGroup).use(Radio).use(Icon).use(Toast).use(Popup).use(Picker).use(Sidebar).use(SidebarItem).use(Tag).use(Stepper).use(Field)
            .use(Switch).use(Button).use(Calendar);
    export default {
        name: 'SaiApplyFormStep2',
        components: {
            [Field.name]: Field,
            PicUploader,
            FileUploader,
            CaipanPicker,
            JiaolianPicker,
            FamliyPicker,
        },
        data: function () {
            return {
                validator,
                saveLoading:false,
                dateShow:false,
                showFamliyPicker:false,
                areaList:{},
                areaValue:'',
                submitType:'',
                row:{
                    yundongyuan_shisu_count:0,
                    date_range:[],
                    saiqu:{}
                },
                formData: {
                    id: 0,
                    famliy:[],
                    date_range:[]
                },
            }
        },
        filters: {},
        computed:{
            sai_member_count(){
            return  this.row.jiaolian_shisu_count+this.row.yundongyuan_shisu_count+this.row.suixing_shisu_count+this.row.lingdui_shisu_count;
            }
        },
        mounted() {
            document.title = '确认人数';
            let that = this;
            that.areaList = area;
            that.formData.id = this.$route.query.id;
            if(that.formData.id){
                this.fetch();
            }
        },
        watch: {
            formData() {
            }
        },
        destroyed() {
        },
        methods: {
            onQuestion(){
                console.log('onQuestion')
            },
            onDateConfirm(date){
                console.log('onDateConfirm',date)
                this.dateShow = false;
                this.formData.date_range =date;
                this.row.date_range = [this.formatDate2(date[0]),this.formatDate2(date[1])];
            },
            onFamliyConfirm(values){
                console.log('onFamliyConfirm',values)
                this.showFamliyPicker = false;
                this.formData.famliy = [...values];
            },
            onFamliyChange(values){
                console.log('onYundongyaunChange',values)
                this.formData.famliy = [...values];
            },
            onSubmit(values){
                console.log('onSubmit-values',values);
                console.log('submitType',this.submitType);

                let that = this;
                console.log(that.formData)
                that.formValidate = true;
                for (let field in that.formData) {
                }
                that.saveLoading = true;

                that.$api.post('/api/sai/famliysave', {
                    id:that.formData.id,
                    need_shisu:that.formData.need_shisu,
                    yundongyuan_shisu_count:that.row.yundongyuan_shisu_count,
                    jiaolian_shisu_count:that.row.jiaolian_shisu_count,
                    lingdui_shisu_count:that.row.lingdui_shisu_count,
                    suixing_shisu_count:that.row.suixing_shisu_count,
                    date_range:that.row.date_range,
                }, (res) => {
                    that.saveLoading = false;

                    appEvent({
                        name: 'saiApplyDetailReload',
                        query: {
                        }
                    });

                    setTimeout(function () {

                        if(that.formData.need_shisu==2){
                            // 直接跳到下一步订单信息 而不是后退
                            rbLink({
                                name:'ISaiApplyFormStep5',
                                query:{
                                    id:that.formData.id
                                }
                            },'replace')
                            // rbLink({
                            //     name:'ISaiApplyDetail',
                            //     query:{
                            //         id:that.formData.id
                            //     }
                            // },'back')
                        }else{

                            rbLink({
                                name:'ISaiApplyFormStep4',
                                query:{
                                    id:that.formData.id
                                }
                            },'replace')

                        }

                    },50)

                }, (res) => {
                    Toast.fail(res.msg);
                    that.saveLoading = false;
                })
            },
            save(values){
                this.submitType = 'save';
            },
            onFailed(errorInfo){
                console.log('failed', errorInfo);
            },
            submit(values) {
                this.submitType = 'submit';
            },
            // 转换函数：时间戳 -> 年-月-日
            formatDate (timestamp) {
                const date = new Date(timestamp);
                const year = date.getFullYear();
                const month = String(date.getMonth() + 1).padStart(2, '0'); // 月份从0开始，补零
                const day = String(date.getDate()).padStart(2, '0'); // 日期补零
                return `${year}-${month}-${day}`;
            },
            //转换函数：日期对象 -> 年-月-日
            formatDate2 (date) { 
                const year = date.getFullYear();
                const month = String(date.getMonth() + 1).padStart(2, '0'); // 月份从0开始，补零
                const day = String(date.getDate()).padStart(2, '0'); // 日期补零
                return `${year}-${month}-${day}`;
            },
            fetch(){
                let that = this;
                that.$api.post('/api/sai/step3detail', {
                    id:that.formData.id
                }, (res) => {
                    that.row = res.data;
                    that.formData.date_range = [new Date(res.data.date_range[0]),new Date(res.data.date_range[1])];
                    that.row.date_range = [that.formatDate(res.data.date_range[0]),that.formatDate(res.data.date_range[1])];
                    // console.log('that.row',that.row)
                    // that.formData.famliy = res.data.famliy;
                }, (res) => {
                    Toast.fail(res.msg);
                });
            }

        }
    }
</script>



// WEBPACK FOOTER //
// SaiApplyFormStep3.vue?47fc9f90